import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VehicleTypeModalService {

  private selectedVehicleTypeSubject = new BehaviorSubject<any>(null);
  public selectedVehicleType$ = this.selectedVehicleTypeSubject.asObservable();

  constructor() { }

  setSelectedVehicleType(vehicleType: any): void {
    this.selectedVehicleTypeSubject.next(vehicleType);
  }

  getSelectedVehicleType(): any | null {
    return this.selectedVehicleTypeSubject.value;
  }

  clearSelectedVehicleType(): void {
    this.selectedVehicleTypeSubject.next(null);
  }
}
